import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { MobileQueryService } from './mobile-query.service';
import { uiStateReducer } from './ui-state.reducer';

@NgModule({
  imports: [CommonModule, LayoutModule, StoreModule.forFeature('uiState', uiStateReducer)],
  providers: [MobileQueryService],
})
export class UiStateModule {
  constructor(private mqs: MobileQueryService) {}
}
